(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cross-sell-modal"] && !Shopify.designMode) return;
  try {
    
  class CrossSellModal extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;

      this.items = this.querySelector('uwp-cart-items');
      this.cartContents = this.querySelector('.cross-sell-modal__purchase');
      this.content = this.querySelector('.cross-sell-modal__content');

      this.cacheDiscountElements();
      this.readPromotionData();

      this.modalVisibilityObserver = new MutationObserver(() => {
        if (!this.hidden) this.initializeCarousel();
      });

      // Submit events
      this.addEventListener('submit', (event) => {
        const targetClasslist = event.target.classList;
        if (targetClasslist.contains('cross-sell-modal__card-form')) {
          event.preventDefault();
          event.stopPropagation();
          this.addItemToCart(event);
        } else if (targetClasslist.contains('cross-sell-modal__giftcode-form')) {
          event.preventDefault();
          event.stopPropagation();
          this.applyDiscount(event);
        }
      });

      this.addEventListener('change', (event) => {
        const variantSelector = event.target.closest?.('.cross-sell-modal__card-form select[name="id"]');
        if (variantSelector instanceof HTMLSelectElement) this.updateCardDiscountPrice(variantSelector);
      });

      // Click events
      this.addEventListener('click', (event) => {
        const targetClasslist = event.target.classList;
        if (
          targetClasslist.contains('cross-sell-modal__discount-input') ||
          event.target.closest('.cross-sell-modal__discount-input')
        ) {
          // Hide all error and success messages if the input is targeted
          this.hideDiscountCodeAlerts();
        } else if (
          targetClasslist.contains('cross-sell-modal__remove-discount') ||
          event.target.closest('.cross-sell-modal__remove-discount')
        ) {
          this.removeDiscount(event);
        }
      });

      document.addEventListener('click', this.closeModal);
      document.addEventListener('click', this.openModal);

      this.addEventListener('newItemForModal', (event) => {
        const addedLineItemId = event.detail.addedLineItemId;
        if (addedLineItemId) this.addedLineItemId = addedLineItemId;
        const updatedHtmlForModal = event.detail.html;
        if (updatedHtmlForModal) {
          this.rerenderCartItems(updatedHtmlForModal);
          this.rerenderPromotion(updatedHtmlForModal);
        }
      });
    }

    cacheDiscountElements() {
      this.discountForms = this.querySelectorAll('.cross-sell-modal__giftcode-form');
      this.discountInputs = this.querySelectorAll('.cross-sell-modal__giftcode-form input');
      this.discountErrorCons = this.querySelectorAll('.cross-sell-modal__giftcode-errors');
      this.discountSuccesses = this.querySelectorAll('.cross-sell-modal__giftcode-success');
      this.discountErrorsGeneral = this.querySelectorAll('.cross-sell-modal__giftcode-general-error');
      this.discountErrorsShipping = this.querySelectorAll('.cross-sell-modal__giftcode-shipping-error');
      this.discountErrorsItemRequirements = this.querySelectorAll('.cross-sell-modal__item-requirements-missed');
      this.appliedDiscountCons = this.querySelectorAll('.cross-sell-modal__discounts');
    }

    readPromotionData() {
      this.freeProductCodeArr = this.dataset.c
        ? this.dataset.c
          .toUpperCase()
          .split(',')
          .map((code) => code.trim())
          .filter(Boolean)
        : [];

      this.accessoryDiscountCodeArr = this.dataset.ac
        ? this.dataset.ac
          .toUpperCase()
          .split(',')
          .map((code) => code.trim())
          .filter(Boolean)
        : [];

      this.accessoryRequirementMap = new Map();
      (this.dataset.prm || '').split('|').forEach((entry) => {
        if (!entry) return;
        const separatorIndex = entry.indexOf(':');
        if (separatorIndex < 0) return;

        const code = entry.slice(0, separatorIndex).trim().toUpperCase();
        const productIds = entry
          .slice(separatorIndex + 1)
          .split(',')
          .map((productId) => productId.trim())
          .filter(Boolean);

        if (code) this.accessoryRequirementMap.set(code, productIds);
      });

      this.freeVariantMap = new Map();
      (this.dataset.fvm || '').split('|').forEach((entry) => {
        if (!entry) return;
        const separatorIndex = entry.indexOf(':');
        if (separatorIndex < 0) return;

        const code = entry.slice(0, separatorIndex).trim().toUpperCase();
        const variantIds = entry
          .slice(separatorIndex + 1)
          .split(',')
          .map((variantId) => variantId.trim())
          .filter(Boolean);

        if (code) this.freeVariantMap.set(code, variantIds);
      });
    }

    connectedCallback() {
      this.addEventListener('toggle', this.onDeliveryInfoToggle, true);
      this.modalVisibilityObserver.observe(this, { attributes: true, attributeFilter: ['hidden'] });
      if (!this.hidden) this.initializeCarousel();
    }

    disconnectedCallback() {
      this.removeEventListener('toggle', this.onDeliveryInfoToggle, true);
      document.removeEventListener('click', this.closeModal);
      document.removeEventListener('click', this.openModal);
      this.modalVisibilityObserver.disconnect();
      if (this.flkty) this.flkty.destroy();
    }

    onDeliveryInfoToggle = (event) => {
      const details = event.target;
      if (!details.matches('.cross-sell-modal__delivery-info') || !(details instanceof HTMLDetailsElement)) return;
      if (details.open) setTimeout(() => details.scrollIntoView({ behavior: 'smooth' }), 300);
    };

    initializeCarousel() {
      if (this.flkty) {
        this.flkty.destroy();
        this.flkty = null;
      }

      const carousel = this.querySelector('.cross-sell-modal__carousel');
      const noOfCards = this.querySelectorAll('.cross-sell-modal__card').length;

      // Use the slider whenever there is more than one eligible promotion card.
      if (carousel && noOfCards > 1 && typeof Flickity !== 'undefined') {
        this.flkty = new Flickity(carousel, {
          cellAlign: 'left',
          contain: true,
          pageDots: false,
        });
        this.flkty.resize();
      }
    }

    rerenderPromotion(html) {
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      const newModal = parsedHtml.querySelector('cross-sell-modal');
      const promotionPanel = this.querySelector('[data-promotion-panel]');
      const newPromotionPanel = parsedHtml.querySelector('[data-promotion-panel]');

      if (!newModal || !promotionPanel || !newPromotionPanel) return;

      promotionPanel.replaceWith(newPromotionPanel);

      const currentTitle = this.querySelector('.cross-sell-modal__title');
      const newTitle = parsedHtml.querySelector('.cross-sell-modal__title');
      if (currentTitle && newTitle) currentTitle.innerHTML = newTitle.innerHTML;

      ['v', 'c', 'ac', 'pr', 'prm', 'fvm', 'fgc', 'agc'].forEach((key) => {
        this.dataset[key] = newModal.dataset[key] || '';
      });

      if (newModal.hasAttribute('aria-describedby')) {
        this.setAttribute('aria-describedby', newModal.getAttribute('aria-describedby'));
      } else {
        this.removeAttribute('aria-describedby');
      }

      const newContent = parsedHtml.querySelector('.cross-sell-modal__content');
      if (this.content && newContent) {
        this.content.classList.toggle(
          'cross-sell-modal__content--free-gifts',
          newContent.classList.contains('cross-sell-modal__content--free-gifts')
        );
      }

      this.cacheDiscountElements();
      this.readPromotionData();
      this.initializeCarousel();
    }

    rerenderCartItems = (html) => {
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      const newItemsHtml = parsedHtml.querySelector('uwp-cart-items');
      if (!newItemsHtml) return;
      this.items.innerHTML = newItemsHtml.innerHTML;
      const newlyUpdatedItem = this.querySelector(`[data-line-item-id="${this.addedLineItemId}"]`);
      if (newlyUpdatedItem) newlyUpdatedItem.classList.add('cross-sell-modal__new-item');
    };

    openModal = (event) => {
      const trigger = event.target.closest?.(
        '[data-cross-sell-modal-open], a[href$="#promotions"]'
      );

      if (!trigger) return;

      event.preventDefault();

      this.removeAttribute('hidden');

      const body = document.querySelector('body');
      if (body) body.style.overflow = 'hidden';

      this.focus();
    };

    closeModal = (e) => {
      var target = e.target;
      if (!target.closest) return;
      if (target.matches('[data-cross-sell-modal-close]')) {
        const modal = target.closest('.cross-sell-modal');
        if (!modal || modal !== this) return;
        if (modal) {
          modal.setAttribute('hidden', '');
          if (document.querySelector('body')) document.querySelector('body').style.overflow = '';
        }
      }
    };

    applyDiscount = async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const discountCode = form.querySelector('input[name="discount"]');
      if (!(discountCode instanceof HTMLInputElement) || typeof this.dataset.sectionId !== 'string') return;

      const discountCodeValue = discountCode.value.toUpperCase().trim();
      const existingDiscounts = this.getExistingDiscounts();
      if (!discountCodeValue || existingDiscounts.includes(discountCodeValue)) {
        discountCode.value = '';
        this.handleDiscountError('discount_code');
        return;
      }

      const applyingAccessoryDiscountCode = this.accessoryDiscountCodeArr.includes(discountCodeValue);
      const applyingFreeGiftDiscountCode = this.freeProductCodeArr.includes(discountCodeValue);
      const applyingDeferredPromotionCode = applyingAccessoryDiscountCode || applyingFreeGiftDiscountCode;

      // Validate and retain configured promotion codes even if Shopify needs another cart item before applying them.
      if (applyingDeferredPromotionCode) {
        const mappedRequirements = this.accessoryRequirementMap.has(discountCodeValue)
          ? this.accessoryRequirementMap.get(discountCodeValue)
          : (this.dataset.pr || '').split(',').filter(Boolean);
        const itemsArr = [...this.querySelectorAll('uwp-cart-item')];

        // If the configured qualifying item is missing, do not store or apply the code.
        if (mappedRequirements.length > 0) {
          const cartProductIdArr = itemsArr.map((item) => item.dataset.lineItemProductId);
          const cartMeetsRequirements = cartProductIdArr.some(
            (productId) => productId && mappedRequirements.includes(productId)
          );

          if (!cartMeetsRequirements) {
            this.handleDiscountError('item_requirements');
            return;
          }
        }
      }

      try {
        form.classList.add('is-loading');

        this.hideDiscountCodeAlerts();

        const requestBody = {
          discount: [...existingDiscounts, discountCodeValue].join(','),
          sections: this.sectionId,
        };

        if (applyingAccessoryDiscountCode) {
          requestBody.attributes = { accessory_code: discountCodeValue };
        } else if (applyingFreeGiftDiscountCode) {
          requestBody.attributes = { free_gift_code: discountCodeValue };
        }

        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });

        const data = await response.json();

        const addedDiscountIsNotApplicable = data.discount_codes.find((discount) => {
          return discount.code === discountCodeValue && discount.applicable === false;
        });

        const promotionCodeIsPending = Boolean(addedDiscountIsNotApplicable && applyingDeferredPromotionCode);

        if (addedDiscountIsNotApplicable && !applyingDeferredPromotionCode) {
          discountCode.value = '';
          this.handleDiscountError('discount_code');
          return;
        }

        if (typeof hj !== 'undefined' && hj) hj('event', 'cross-sell-modal_discount-code-applied');

        //Rerender modal UI
        if (data && data.sections && data.sections[this.sectionId]) {
          this.rerenderPromotion(data.sections[this.sectionId]);
          this.rerenderCartItems(data.sections[this.sectionId]);
        }

        const newHtml = data.sections[this.sectionId];
        const section = new DOMParser().parseFromString(newHtml, 'text/html');
        const discountCodes = section?.querySelectorAll('.cross-sell-modal__discount') || [];
        if (section) {
          const codes = Array.from(discountCodes)
            .map((element) => (element instanceof HTMLLIElement ? element.dataset.discountCode : null))
            .filter(Boolean);
          // Before updating applied discounts, we need to check if the shipping discount is applicable in the UI
          // we check the liquid logic compared to the cart payload to assess whether we leveraged
          // a valid shipping discount code.
          if (
            codes.length === existingDiscounts.length &&
            codes.every((code) => existingDiscounts.includes(code)) &&
            data.discount_codes.find((discount) => {
              return discount.code === discountCodeValue && discount.applicable === true;
            })
          ) {
            this.handleDiscountError('shipping');
            discountCode.value = '';
            return;
          }

          const newDiscountsHtml = section.querySelector('.cross-sell-modal__discounts');
          if (newDiscountsHtml) {
            this.appliedDiscountCons.forEach((con) => (con.innerHTML = newDiscountsHtml.innerHTML));
          }

          if (!promotionCodeIsPending) {
            this.discountSuccesses.forEach((success) => (success.hidden = false));
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        discountCode.value = '';
        form.classList.remove('is-loading');
      }
    };

    removeDiscount = async (event) => {
      event.preventDefault();
      event.stopPropagation();
      const closestDiscountCon = event.target.closest('.cross-sell-modal__discount');
      if (!closestDiscountCon) return;
      const discountCode = closestDiscountCon.dataset.discountCode;
      if (!discountCode) return;

      const activeDiscountArr = this.getExistingDiscounts().filter((code) => code !== discountCode);

      this.hideDiscountCodeAlerts();

      const requestBody = {
        updates: {},
        discount: activeDiscountArr.join(),
        sections: this.sectionId,
      };

      ///If removing an accessory discount rather than a regular discount, make sure to remove the attribute as well
      if (
        closestDiscountCon.dataset.accessoryDiscountCode &&
        closestDiscountCon.dataset.accessoryDiscountCode == 'true'
      ) {
        requestBody.attributes = { accessory_code: '' };
      }

      // Removing one free-gift code removes only the variants configured for that promotion.
      if (this.freeProductCodeArr.includes(discountCode.toUpperCase())) {
        requestBody.attributes = {
          ...(requestBody.attributes || {}),
          free_gift_code: '',
        };

        const possibleFreeVariantIdArr = this.freeVariantMap.has(discountCode.toUpperCase())
          ? this.freeVariantMap.get(discountCode.toUpperCase())
          : (this.dataset.v || '').split(',').filter(Boolean);

        possibleFreeVariantIdArr.forEach((variantId) => {
          requestBody.updates[variantId] = 0;
        });
      }

      try {
        closestDiscountCon.classList.add('cross-sell-modal__discount--loading');

        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error('The discount code could not be removed');
        }

        const data = await response.json();

        // Remove every desktop/mobile copy of the same code.
        this.querySelectorAll('.cross-sell-modal__discount[data-discount-code]').forEach((discount) => {
          if (discount.dataset.discountCode === discountCode) discount.remove();
        });

        if (typeof hj !== 'undefined' && hj) hj('event', 'cross-sell-modal_discount-code-removed');

        // Rerender the modal and return focus to the discount input when available.
        if (data && data.sections && data.sections[this.sectionId]) {
          this.rerenderPromotion(data.sections[this.sectionId]);
          this.rerenderCartItems(data.sections[this.sectionId]);
        }

        const discountInput = this.querySelector('.cross-sell-modal__discount-input');
        if (discountInput instanceof HTMLInputElement) discountInput.focus();
      } catch (error) {
        closestDiscountCon.classList.remove('cross-sell-modal__discount--loading');
        console.error(error);
      }
    };

    hideDiscountCodeAlerts() {
      if (this.discountErrorCons) this.discountErrorCons.forEach((con) => (con.hidden = true));
      const errorArr = [...this.querySelectorAll('.cross-sell-modal__giftcode-error')];
      if (errorArr && errorArr.length > 0) {
        errorArr.forEach((error) => {
          error.hidden = true;
        });
      }
      if (this.discountSuccesses) this.discountSuccesses.forEach((success) => (success.hidden = true));
    }

    getExistingDiscounts() {
      const discountCodes = new Set();
      const discountPills = this.querySelectorAll('.cross-sell-modal__discount[data-discount-code]');

      for (const pill of discountPills) {
        if (typeof pill.dataset.discountCode === 'string' && pill.dataset.discountCode) {
          discountCodes.add(pill.dataset.discountCode);
        }
      }

      return [...discountCodes];
    }

    updateCardDiscountPrice(variantSelector) {
      const selectedOption = variantSelector.options[variantSelector.selectedIndex];
      const card = variantSelector.closest('.cross-sell-modal__card');
      const price = card?.querySelector('[data-discount-price-preview]');
      const originalPrice = price?.querySelector('[data-original-price]');
      const discountedPrice = price?.querySelector('[data-discounted-price]');

      if (!selectedOption || !price || !originalPrice || !discountedPrice) return;

      if (selectedOption.dataset.originalPrice) {
        originalPrice.textContent = selectedOption.dataset.originalPrice;
      }

      if (selectedOption.dataset.discountedPrice) {
        discountedPrice.textContent = selectedOption.dataset.discountedPrice;
      }

      if (this.flkty) this.flkty.resize();
    }

    handleDiscountError(type) {
      const target =
        type === 'discount_code'
          ? this.discountErrorsGeneral
          : type === 'shipping'
          ? this.discountErrorsShipping
          : this.discountErrorsItemRequirements;
      this.discountErrorCons.forEach((con) => (con.hidden = false));
      target.forEach((error) => (error.hidden = false));
    }

    addItemToCart = async (event) => {
      this.hideDiscountCodeAlerts();

      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      // Only have to worry about a single variant selector as the Liquid is set up not to render products with more than one variant option
      const variantSelector = form.querySelector('select');

      const card = form.closest('.cross-sell-modal__card');
      if (!card) return;

      if (variantSelector && !variantSelector.value) {
        console.error('No variant selected');
        const errorAlert = card.querySelector('.cross-sell-modal__card-error');
        if (errorAlert) errorAlert.hidden = false;
        //Need to resize carousel so the error is visible
        if (this.flkty) this.flkty.resize();
        return;
      }

      try {
        const formData = new FormData(form);

        form.classList.add('is-loading');
        formData.append('sections', this.sectionId);

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          body: formData,
        });

        // Minimum delay so the request isn't too fast, causing confusing layout shift
        const minimumFetchDuration = 300;

        const [fetchResult] = await Promise.all([
          response,
          new Promise((resolve) => setTimeout(resolve, minimumFetchDuration)),
        ]);

        if (!fetchResult.ok) {
          throw new Error('Something went wrong');
        }

        let data = await fetchResult.json();
        let deferredPromotionCodeFailed = false;

        // Shopify can't apply some product discounts until an eligible item exists in the cart.
        // Reapply any pending free-gift or accessory code immediately after the product is added.
        const pendingFreeGiftCode = (this.dataset.fgc || '').trim().toUpperCase();
        const pendingAccessoryCode = (this.dataset.agc || '').trim().toUpperCase();
        const pendingPromotionCodes = [pendingFreeGiftCode, pendingAccessoryCode].filter(Boolean);

        if (pendingPromotionCodes.length > 0) {
          const discountCodes = [...this.getExistingDiscounts(), ...pendingPromotionCodes]
            .filter((code, index, codes) => code && codes.indexOf(code) === index);

          const discountResponse = await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              discount: discountCodes.join(','),
              sections: this.sectionId,
            }),
          });

          if (!discountResponse.ok) {
            throw new Error('The pending promotion discount could not be reapplied');
          }

          data = await discountResponse.json();
          deferredPromotionCodeFailed = pendingPromotionCodes.some((pendingCode) =>
            data.discount_codes?.some(
              (discount) => discount.code?.toUpperCase() === pendingCode && discount.applicable === false
            )
          );
        }

        if (typeof hj !== 'undefined' && hj) hj('event', 'cross-sell-modal_item-added-to-cart');

        //Refresh cart to add free product to it
        if (data && data.sections && data.sections[this.sectionId]) {
          this.rerenderCartItems(data.sections[this.sectionId]);
          this.rerenderPromotion(data.sections[this.sectionId]);
        }

        if (deferredPromotionCodeFailed) {
          this.handleDiscountError('discount_code');
        }

        if (this.cartContents) this.cartContents.scrollIntoView({ behavior: 'smooth' });
      } catch (error) {
        console.error(error);
      } finally {
        form.classList.remove('is-loading');
      }
    };

    hideFreeProductError(event) {
      const input = event.target;
      const freeProduct = input.closest('.cross-sell-modal__free-product');
      if (!freeProduct) return;
      const errorAlert = freeProduct.querySelector('.cross-sell-modal__free-product-error');
      if (errorAlert) errorAlert.hidden = true;
    }
  }

  if (!customElements.get('cross-sell-modal')) {
    customElements.define('cross-sell-modal', CrossSellModal);
  }

  } catch(e) { console.error(e); }
})();
})();
